import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getAssetForSource, loadSingleFontAsync, fontFamilyNeedsScoping, getNativeFontName } from "./FontLoader";
var loaded = {};
var loadPromises = {};
export function processFontFamily(name) {
  if (!name || !fontFamilyNeedsScoping(name)) {
    return name;
  }

  if (!isLoaded(name)) {
    if (__DEV__) {
      if (isLoading(name)) {
        console.error("You started loading the font \"" + name + "\", but used it before it finished loading.\n\n- You need to wait for Font.loadAsync to complete before using the font.\n\n- We recommend loading all fonts before rendering the app, and rendering only Expo.AppLoading while waiting for loading to complete.");
      } else {
        console.error("fontFamily \"" + name + "\" is not a system font and has not been loaded through Font.loadAsync.\n\n- If you intended to use a system font, make sure you typed the name correctly and that it is supported by your device operating system.\n\n- If this is a custom font, be sure to load it with Font.loadAsync.");
      }
    }

    return 'System';
  }

  return "ExpoFont-" + getNativeFontName(name);
}
export function isLoaded(name) {
  return loaded.hasOwnProperty(name);
}
export function isLoading(name) {
  return loadPromises.hasOwnProperty(name);
}
export function loadAsync(nameOrMap, source) {
  var fontMap, names, name, asset;
  return _regeneratorRuntime.async(function loadAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(typeof nameOrMap === 'object')) {
            _context2.next = 6;
            break;
          }

          fontMap = nameOrMap;
          names = Object.keys(fontMap);
          _context2.next = 5;
          return _regeneratorRuntime.awrap(Promise.all(names.map(function (name) {
            return loadAsync(name, fontMap[name]);
          })));

        case 5:
          return _context2.abrupt("return");

        case 6:
          name = nameOrMap;

          if (!loaded[name]) {
            _context2.next = 9;
            break;
          }

          return _context2.abrupt("return");

        case 9:
          if (!loadPromises[name]) {
            _context2.next = 11;
            break;
          }

          return _context2.abrupt("return", loadPromises[name]);

        case 11:
          if (source) {
            _context2.next = 13;
            break;
          }

          throw new Error("No source from which to load font \"" + name + "\"");

        case 13:
          asset = getAssetForSource(source);

          loadPromises[name] = function _callee() {
            return _regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return _regeneratorRuntime.awrap(loadSingleFontAsync(name, asset));

                  case 3:
                    loaded[name] = true;

                  case 4:
                    _context.prev = 4;
                    delete loadPromises[name];
                    return _context.finish(4);

                  case 7:
                  case "end":
                    return _context.stop();
                }
              }
            }, null, null, [[0,, 4, 7]]);
          }();

          _context2.next = 17;
          return _regeneratorRuntime.awrap(loadPromises[name]);

        case 17:
        case "end":
          return _context2.stop();
      }
    }
  });
}

if (module && module.exports) {
  var wasImportWarningShown = false;
  Object.defineProperty(exports, 'Font', {
    get: function get() {
      if (!wasImportWarningShown) {
        console.warn("The syntax \"import { Font } from 'expo-font'\" is deprecated. Use \"import * as Font from 'expo-font'\" or import named exports instead. Support for the old syntax will be removed in SDK 33.");
        wasImportWarningShown = true;
      }

      return {
        processFontFamily: processFontFamily,
        isLoaded: isLoaded,
        isLoading: isLoading,
        loadAsync: loadAsync
      };
    }
  });
}